import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SEO component for managing meta tags
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} [props.image] - OpenGraph image URL
 * @param {string} [props.url] - Canonical URL
 * @returns {React.ReactElement} SEO component with Helmet
 */
const SEO = ({ title, description, image, url }) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://lonestaraerialsolutions.com';
  const defaultImage = '/assets/og-image.jpg';
  
  const metaTitle = title || 'Lone Star Aerial Solutions | Professional Drone Services in Texas';
  const metaDescription = description || 'Professional drone services across Texas including aerial photography, videography, mapping, and inspections for businesses and real estate.';
  const metaImage = image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`;
  const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaUrl} />

      {/* OpenGraph tags */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lone Star Aerial Solutions" />

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default SEO;
